// extracted by mini-css-extract-plugin
module.exports = {"sortByTrigger":"Insights_sortByTrigger__a62Zn","sortBy":"Insights_sortBy__uHlb6","sortBySelect":"Insights_sortBySelect__rMx6k"};